import React, { useState } from "react";
import "./styles/hero.css";
import PatternDesign from "../../components/PatternDesign";

const Hero = () => {
  return (
    <>
     <PatternDesign/>
      <section className="hero-section">
        <div className="container hero-container">
      
            <h1 className="hero-heading">
              Monetize Smarter,
              <br />
              Engage Better, Grow Faster.
            </h1>
{/* 
          <div className="hero-intro">
            <p>
              Welcome to Real Opinion, the smarter way to monetize your app.
            </p>
          </div> */}
          <div className="hero-img-box">
            <img src="images/hero1.png" alt="Hero_1" />
            <img src="images/hero2.png" alt="Hero_2" />
            <img src="images/hero3.png" alt="Hero_3" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
